import Api from "../../axios";

export const putEditFeedback = async ({ id, description, is_publish }) => {
  return await Api.put(`/edit_feedback/${id}`, {
    description,
    is_publish,
  });
};
